var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMountainsLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.643 26.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6089bd;\n        stroke: #6089bd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1800663_cc",
    transform: "translate(0.574 -33.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(0 34.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-1",
    d: "M41.4,55.912,24.89,34.386a.785.785,0,0,0-.624-.308h0a.788.788,0,0,0-.625.309L12.309,49.214l-2.135-2.782a.786.786,0,0,0-.624-.308h0a.786.786,0,0,0-.624.309L.162,57.9a.787.787,0,0,0,1.25.956L4.737,54.5,5.79,55.961a.787.787,0,0,0,.535.319.775.775,0,0,0,.1.007.786.786,0,0,0,.5-.177l2.5-2.036,2.336,2.021a.787.787,0,0,0,1.144-.121l1.291-1.714,3.527,4.6A.787.787,0,1,0,18.97,57.9L13.3,50.508l4.39-5.745,2.031,2.93a.786.786,0,0,0,.588.337l.059,0a.785.785,0,0,0,.572-.247l3.066-3.251,2.445,2.988a.774.774,0,0,0,.637.287.787.787,0,0,0,.616-.333l2.507-3.565,9.943,12.96a.787.787,0,0,0,1.248-.958ZM12.153,54.353l-2.2-1.9a.785.785,0,0,0-1.012-.015L6.577,54.362,5.735,53.2,9.551,48.2l3.65,4.757Zm14.862-8.631-2.356-2.879a.785.785,0,0,0-.581-.287.744.744,0,0,0-.6.247L20.463,46,18.7,43.449l5.571-7.29L29.209,42.6Z",
    transform: "translate(0 -34.078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMountainsLightBlue);
export default __webpack_public_path__ + "static/media/icon-mountains-light-blue.85725a958d0aa3874b5a30351f79be48.svg";
export { ForwardRef as ReactComponent };